import React from 'react';
import './FrontendFooter.css';
import Powerdby from "../../assets/images/vizagprofiles.png";
import { Box } from '@mui/material';
import F9techLogo from "../../assets/images/f9tech-logo.png";

const FrontendFooter = () => {
  return (
    <footer className="frontend-footer">
      <div className="footer-content">



<div className='powered-by'><span>Powered By</span>
  
   <a className='powered-by-link' href="https://vizagprofiles.com/" target="_blank" rel="noreferrer"><img src={Powerdby} alt="Powered By" /></a>

</div>




        {/* Social Media Icons */}
        {/* <div className="footer-social">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <i className="fab fa-facebook"></i>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <i className="fab fa-twitter"></i>
          </a>
          <a href="https://plus.google.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <i className="fab fa-google-plus"></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <i className="fab fa-youtube"></i>
          </a>
        </div> */}

        {/* Navigation Links */}
        <div className="footer-nav">
          {/* <a href="/" className="nav-link">
         
            Home
          </a>
       
          <a href="/about" className="nav-link">
         
            About
          </a>
          <a href="/contact" className="nav-link">
       
            Contact Us
          </a>
          <a href="/enquiry" className="nav-link">
          
          Enquiries
          </a> */}

<a href="/privacy-policy" className="nav-link">
            Privacy Policy
          </a>
          <a href="/terms-and-conditions" className="nav-link">
            Terms and Conditions
          </a>
          {/* <a href="/delete-account" className="nav-link">
            Delete Account
          </a> */}




        </div>

        {/* Copyright Notice */}





      </div>


      <Box className="footer-copyright">
        <div className="footer-copyright-content">
          <p>© {new Date().getFullYear()} Steel Buddy. All Rights Reserved.</p>
          <div className="developer-credit">Developed By
            <a href="https://f9tech.com/" target="_blank" rel="noreferrer"> 
              <img src={F9techLogo} alt="F9tech" className="f9tech-logo" />
            </a>
          </div>
        </div>
      </Box>





    </footer>
  );
};

export default FrontendFooter;